import { C } from "../constants/colors";

// ── Shared helpers ──
const ff = "'Outfit',sans-serif";
const label = (x, y, text, color, size=11, anchor="middle", weight="400") => (
  <text x={x} y={y} fontSize={size} fill={color||C.textMid} fontFamily={ff} textAnchor={anchor} fontWeight={weight}>{text}</text>
);
const arrow = (x1,y1,x2,y2,color,w=1.5) => {
  const dx=x2-x1,dy=y2-y1,len=Math.sqrt(dx*dx+dy*dy);
  const ux=dx/len,uy=dy/len;
  const ax=x2-ux*8,ay=y2-uy*8;
  return (<g><line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth={w}/><polygon points={`${x2},${y2} ${ax-uy*4},${ay+ux*4} ${ax+uy*4},${ay-ux*4}`} fill={color}/></g>);
};

// ═══════════════════════════════════════
//  LINES & ANGLES (Class 9 Ch 6)
// ═══════════════════════════════════════

export function SvgAngleTypes() {
  return (
    <svg viewBox="0 0 400 160" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {/* Acute */}
      <line x1="20" y1="130" x2="100" y2="130" stroke={C.primaryMid} strokeWidth="2"/>
      <line x1="20" y1="130" x2="75" y2="60" stroke={C.primaryMid} strokeWidth="2"/>
      <path d="M 40 130 A 20 20 0 0 1 33 113" fill="none" stroke={C.amber} strokeWidth="1.5"/>
      {label(55, 150, "Acute", C.primaryMid, 12, "middle", "600")}
      {label(55, 108, "45°", C.amber, 10)}
      {/* Right */}
      <line x1="150" y1="130" x2="240" y2="130" stroke={C.primaryMid} strokeWidth="2"/>
      <line x1="150" y1="130" x2="150" y2="50" stroke={C.primaryMid} strokeWidth="2"/>
      <rect x="150" y="112" width="16" height="16" fill="none" stroke={C.amber} strokeWidth="1.5"/>
      {label(190, 150, "Right", C.primaryMid, 12, "middle", "600")}
      {label(178, 108, "90°", C.amber, 10)}
      {/* Obtuse */}
      <line x1="280" y1="130" x2="380" y2="130" stroke={C.primaryMid} strokeWidth="2"/>
      <line x1="280" y1="130" x2="320" y2="50" stroke={C.primaryMid} strokeWidth="2"/>
      <path d="M 300 130 A 20 20 0 0 1 290 110" fill="none" stroke={C.amber} strokeWidth="1.5"/>
      {label(330, 150, "Obtuse", C.primaryMid, 12, "middle", "600")}
      {label(310, 105, "120°", C.amber, 10)}
      {/* Title */}
      {label(200, 20, "Types of Angles", C.text, 13, "middle", "600")}
    </svg>
  );
}

export function SvgParallelTransversal() {
  return (
    <svg viewBox="0 0 400 240" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Parallel Lines + Transversal", C.text, 13, "middle", "600")}
      {/* Parallel lines */}
      <line x1="40" y1="80" x2="360" y2="80" stroke={C.primaryMid} strokeWidth="2"/>
      <line x1="40" y1="170" x2="360" y2="170" stroke={C.primaryMid} strokeWidth="2"/>
      {/* Arrow marks for parallel */}
      <polygon points="185,76 190,80 185,84" fill={C.primaryMid}/>
      <polygon points="185,166 190,170 185,174" fill={C.primaryMid}/>
      {/* Labels */}
      {label(370, 84, "l₁", C.primaryMid, 12, "start", "600")}
      {label(370, 174, "l₂", C.primaryMid, 12, "start", "600")}
      {/* Transversal */}
      <line x1="100" y1="30" x2="300" y2="220" stroke={C.amber} strokeWidth="2"/>
      {label(92, 28, "t", C.amber, 12, "middle", "600")}
      {/* Angle labels at intersection 1 */}
      {label(175, 68, "1", "#E24B4A", 10)}
      {label(205, 68, "2", C.purpleMid, 10)}
      {label(170, 95, "3", C.purpleMid, 10)}
      {label(200, 95, "4", "#E24B4A", 10)}
      {/* Angle labels at intersection 2 */}
      {label(235, 158, "5", "#E24B4A", 10)}
      {label(265, 158, "6", C.purpleMid, 10)}
      {label(230, 185, "7", C.purpleMid, 10)}
      {label(260, 185, "8", "#E24B4A", 10)}
      {/* Legend */}
      <rect x="40" y="210" width="10" height="10" rx="2" fill="#E24B4A"/>
      {label(55, 219, "∠1=∠5 (corresponding)", C.textMid, 10, "start")}
      <rect x="220" y="210" width="10" height="10" rx="2" fill={C.purpleMid}/>
      {label(235, 219, "∠3=∠5 (alternate)", C.textMid, 10, "start")}
    </svg>
  );
}

export function SvgLinearPair() {
  return (
    <svg viewBox="0 0 400 160" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Linear Pair: ∠a + ∠b = 180°", C.text, 13, "middle", "600")}
      <line x1="40" y1="100" x2="360" y2="100" stroke={C.textMid} strokeWidth="2"/>
      <line x1="200" y1="100" x2="280" y2="30" stroke={C.primaryMid} strokeWidth="2"/>
      <circle cx="200" cy="100" r="4" fill={C.primaryMid}/>
      <path d="M 230 100 A 30 30 0 0 1 220 76" fill="none" stroke={C.amber} strokeWidth="2"/>
      {label(240, 82, "a", C.amber, 13, "middle", "600")}
      <path d="M 170 100 A 30 30 0 0 0 218 77" fill="none" stroke="#E24B4A" strokeWidth="2"/>
      {label(160, 82, "b", "#E24B4A", 13, "middle", "600")}
      {label(200, 140, "∠a + ∠b = 180° (supplementary)", C.textMid, 11)}
    </svg>
  );
}

// ═══════════════════════════════════════
//  TRIANGLES (Class 9 Ch 7, Class 10 Ch 6)
// ═══════════════════════════════════════

export function SvgTriangleTypes() {
  return (
    <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Types of Triangles", C.text, 13, "middle", "600")}
      {/* Equilateral */}
      <polygon points="65,150 115,150 90,70" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      {label(70, 115, "60°", C.amber, 9)}
      {label(90, 168, "Equilateral", C.primaryMid, 11, "middle", "600")}
      {label(90, 182, "all sides equal", C.textMute, 9)}
      {/* Isosceles */}
      <polygon points="175,150 245,150 210,70" fill="#FAEEDA" stroke={C.amberDark} strokeWidth="2"/>
      <line x1="185" y1="110" x2="190" y2="115" stroke={C.amberDark} strokeWidth="1.5"/>
      <line x1="232" y1="110" x2="227" y2="115" stroke={C.amberDark} strokeWidth="1.5"/>
      {label(210, 168, "Isosceles", C.amberDark, 11, "middle", "600")}
      {label(210, 182, "2 sides equal", C.textMute, 9)}
      {/* Scalene */}
      <polygon points="290,150 370,150 350,70" fill="#EEEDFE" stroke={C.purpleMid} strokeWidth="2"/>
      {label(330, 168, "Scalene", C.purpleMid, 11, "middle", "600")}
      {label(330, 182, "no sides equal", C.textMute, 9)}
    </svg>
  );
}

export function SvgAngleSumProperty() {
  return (
    <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Angle Sum Property", C.text, 13, "middle", "600")}
      <polygon points="200,40 80,160 320,160" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2.5"/>
      <circle cx="200" cy="40" r="3" fill={C.primaryMid}/>
      <circle cx="80" cy="160" r="3" fill={C.primaryMid}/>
      <circle cx="320" cy="160" r="3" fill={C.primaryMid}/>
      {/* Angle arcs */}
      <path d="M 190 58 A 18 18 0 0 1 210 58" fill="none" stroke="#E24B4A" strokeWidth="2"/>
      <path d="M 100 157 A 20 20 0 0 0 88 142" fill="none" stroke={C.amber} strokeWidth="2"/>
      <path d="M 300 157 A 20 20 0 0 1 312 142" fill="none" stroke={C.purpleMid} strokeWidth="2"/>
      {/* Labels */}
      {label(200, 35, "A", C.text, 12, "middle", "600")}
      {label(65, 165, "B", C.text, 12, "middle", "600")}
      {label(335, 165, "C", C.text, 12, "middle", "600")}
      {label(200, 75, "∠A", "#E24B4A", 11, "middle", "600")}
      {label(105, 142, "∠B", C.amber, 11, "middle", "600")}
      {label(298, 142, "∠C", C.purpleMid, 11, "middle", "600")}
      {label(200, 190, "∠A + ∠B + ∠C = 180°", C.text, 13, "middle", "600")}
    </svg>
  );
}

export function SvgPythagoras() {
  return (
    <svg viewBox="0 0 400 220" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Pythagoras Theorem", C.text, 13, "middle", "600")}
      {/* Right triangle */}
      <polygon points="100,180 100,60 280,180" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2.5"/>
      {/* Right angle marker */}
      <rect x="100" y="162" width="16" height="16" fill="none" stroke={C.amber} strokeWidth="1.5"/>
      {/* Labels */}
      {label(85, 125, "a = 3", C.primaryMid, 13, "end", "600")}
      {label(190, 198, "b = 4", C.primaryMid, 13, "middle", "600")}
      {label(200, 110, "c = 5", "#E24B4A", 14, "middle", "600")}
      {/* Squares on sides */}
      <rect x="62" y="60" width="38" height="120" rx="2" fill="none" stroke={C.primaryLight} strokeWidth="1" strokeDasharray="4,3"/>
      {label(55, 125, "a²=9", C.textMute, 9, "end")}
      <rect x="100" y="180" width="180" height="30" rx="2" fill="none" stroke={C.primaryLight} strokeWidth="1" strokeDasharray="4,3"/>
      {label(190, 216, "b²=16", C.textMute, 9)}
      {/* Formula */}
      <rect x="280" y="80" width="110" height="40" rx="10" fill="#FAEEDA" stroke={C.amberDark} strokeWidth="1.5"/>
      {label(335, 100, "c² = a² + b²", C.amberDark, 12, "middle", "600")}
      {label(335, 115, "25 = 9 + 16 ✓", C.textMid, 10)}
    </svg>
  );
}

export function SvgSimilarTriangles() {
  return (
    <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Similar Triangles (AA Criterion)", C.text, 13, "middle", "600")}
      {/* Small triangle */}
      <polygon points="60,160 140,160 100,90" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      {label(100, 82, "A", C.text, 11, "middle", "600")}
      {label(48, 168, "B", C.text, 11)}
      {label(145, 168, "C", C.text, 11)}
      {label(70, 135, "3", C.primaryMid, 10, "middle", "600")}
      {label(130, 135, "4", C.primaryMid, 10, "middle", "600")}
      {label(100, 175, "5", C.primaryMid, 10, "middle", "600")}
      {/* Large triangle */}
      <polygon points="220,160 380,160 300,50" fill="#FAEEDA" stroke={C.amberDark} strokeWidth="2"/>
      {label(300, 42, "P", C.text, 11, "middle", "600")}
      {label(208, 168, "Q", C.text, 11)}
      {label(385, 168, "R", C.text, 11)}
      {label(248, 120, "6", C.amberDark, 10, "middle", "600")}
      {label(352, 120, "8", C.amberDark, 10, "middle", "600")}
      {label(300, 175, "10", C.amberDark, 10, "middle", "600")}
      {/* Ratio */}
      {label(200, 195, "AB/PQ = BC/QR = AC/PR = 1:2  →  △ABC ~ △PQR", C.textMid, 11)}
    </svg>
  );
}

export function SvgBPT() {
  return (
    <svg viewBox="0 0 400 220" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Basic Proportionality Theorem (BPT)", C.text, 13, "middle", "600")}
      {/* Triangle */}
      <polygon points="200,40 60,200 340,200" fill="none" stroke={C.textMid} strokeWidth="1.5"/>
      {label(200, 35, "A", C.text, 12, "middle", "600")}
      {label(48, 207, "B", C.text, 12)}
      {label(345, 207, "C", C.text, 12)}
      {/* Parallel line DE */}
      <line x1="115" y1="130" x2="285" y2="130" stroke={C.primaryMid} strokeWidth="2.5"/>
      <circle cx="115" cy="130" r="3.5" fill={C.primaryMid}/>
      <circle cx="285" cy="130" r="3.5" fill={C.primaryMid}/>
      {label(102, 128, "D", C.primaryMid, 12, "end", "600")}
      {label(295, 128, "E", C.primaryMid, 12, "start", "600")}
      {/* Parallel marks */}
      <line x1="195" y1="127" x2="200" y2="133" stroke={C.primaryMid} strokeWidth="1.5"/>
      <line x1="200" y1="127" x2="205" y2="133" stroke={C.primaryMid} strokeWidth="1.5"/>
      <line x1="195" y1="197" x2="200" y2="203" stroke={C.textMid} strokeWidth="1.5"/>
      <line x1="200" y1="197" x2="205" y2="203" stroke={C.textMid} strokeWidth="1.5"/>
      {/* Labels */}
      {label(148, 82, "AD", C.amber, 11, "middle", "600")}
      {label(255, 82, "AE", C.amber, 11, "middle", "600")}
      {label(76, 172, "DB", C.purpleMid, 11, "middle", "600")}
      {label(322, 172, "EC", C.purpleMid, 11, "middle", "600")}
      {/* Formula */}
      <rect x="100" y="205" width="200" height="15" rx="4" fill="none"/>
      {label(200, 217, "If DE ∥ BC, then AD/DB = AE/EC", C.text, 12, "middle", "600")}
    </svg>
  );
}

// ═══════════════════════════════════════
//  CIRCLES (Class 9 Ch 10, Class 10 Ch 10)
// ═══════════════════════════════════════

export function SvgCircleParts() {
  return (
    <svg viewBox="0 0 400 240" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Parts of a Circle", C.text, 13, "middle", "600")}
      <circle cx="180" cy="130" r="85" fill="none" stroke={C.primaryMid} strokeWidth="2"/>
      <circle cx="180" cy="130" r="3" fill={C.primaryMid}/>
      {label(180, 125, "O", C.text, 11, "middle", "600")}
      {/* Radius */}
      <line x1="180" y1="130" x2="250" y2="80" stroke={C.amber} strokeWidth="2"/>
      {label(222, 96, "r", C.amber, 12, "middle", "600")}
      {/* Diameter */}
      <line x1="95" y1="130" x2="265" y2="130" stroke="#E24B4A" strokeWidth="2"/>
      {label(180, 144, "d = 2r", "#E24B4A", 11, "middle", "600")}
      {/* Chord */}
      <line x1="120" y1="70" x2="250" y2="80" stroke={C.purpleMid} strokeWidth="2" strokeDasharray="6,3"/>
      {label(185, 65, "chord", C.purpleMid, 10, "middle", "600")}
      {/* Arc */}
      <path d="M 120 70 A 85 85 0 0 1 250 80" fill="none" stroke={C.greenMid} strokeWidth="3"/>
      {label(195, 38, "arc", C.greenMid, 10, "middle", "600")}
      {/* Legend */}
      <line x1="290" y1="60" x2="310" y2="60" stroke={C.amber} strokeWidth="2"/>
      {label(315, 64, "Radius", C.textMid, 10, "start")}
      <line x1="290" y1="80" x2="310" y2="80" stroke="#E24B4A" strokeWidth="2"/>
      {label(315, 84, "Diameter", C.textMid, 10, "start")}
      <line x1="290" y1="100" x2="310" y2="100" stroke={C.purpleMid} strokeWidth="2" strokeDasharray="6,3"/>
      {label(315, 104, "Chord", C.textMid, 10, "start")}
      <line x1="290" y1="120" x2="310" y2="120" stroke={C.greenMid} strokeWidth="3"/>
      {label(315, 124, "Arc", C.textMid, 10, "start")}
    </svg>
  );
}

export function SvgTangentToCircle() {
  return (
    <svg viewBox="0 0 400 220" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Tangent to a Circle", C.text, 13, "middle", "600")}
      <circle cx="180" cy="120" r="70" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      <circle cx="180" cy="120" r="3" fill={C.primaryMid}/>
      {label(180, 115, "O", C.text, 11, "middle", "600")}
      {/* Point of tangency */}
      <circle cx="250" cy="120" r="4" fill={C.amber}/>
      {label(258, 115, "P", C.text, 11, "start", "600")}
      {/* Tangent line */}
      <line x1="250" y1="40" x2="250" y2="200" stroke={C.amber} strokeWidth="2.5"/>
      {label(260, 45, "Tangent", C.amber, 11, "start", "600")}
      {/* Radius to P */}
      <line x1="180" y1="120" x2="250" y2="120" stroke={C.primaryMid} strokeWidth="2"/>
      {/* Right angle marker */}
      <rect x="234" y="120" width="14" height="14" fill="none" stroke="#E24B4A" strokeWidth="1.5"/>
      {label(220, 140, "r", C.primaryMid, 11, "middle", "600")}
      {/* Key point */}
      {label(200, 210, "OP ⊥ Tangent (radius ⊥ tangent at point of contact)", C.textMid, 11)}
    </svg>
  );
}

export function SvgAngleInSemicircle() {
  return (
    <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Angle in a Semicircle = 90°", C.text, 13, "middle", "600")}
      {/* Semicircle */}
      <path d="M 80 140 A 100 100 0 0 1 320 140" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      <line x1="80" y1="140" x2="320" y2="140" stroke={C.primaryMid} strokeWidth="2"/>
      {/* Center */}
      <circle cx="200" cy="140" r="3" fill={C.primaryMid}/>
      {label(200, 155, "O", C.textMid, 11)}
      {/* Points */}
      <circle cx="80" cy="140" r="4" fill={C.primaryMid}/>
      {label(70, 155, "A", C.text, 11, "middle", "600")}
      <circle cx="320" cy="140" r="4" fill={C.primaryMid}/>
      {label(330, 155, "B", C.text, 11, "middle", "600")}
      <circle cx="220" cy="42" r="4" fill={C.amber}/>
      {label(228, 37, "C", C.text, 11, "start", "600")}
      {/* Lines to C */}
      <line x1="80" y1="140" x2="220" y2="42" stroke={C.amber} strokeWidth="2"/>
      <line x1="320" y1="140" x2="220" y2="42" stroke={C.amber} strokeWidth="2"/>
      {/* Right angle at C */}
      <rect x="210" y="50" width="12" height="12" fill="none" stroke="#E24B4A" strokeWidth="1.5" transform="rotate(-20,216,56)"/>
      {label(245, 60, "90°", "#E24B4A", 12, "start", "600")}
      {label(200, 185, "Angle subtended by diameter on semicircle = 90°", C.textMid, 11)}
    </svg>
  );
}

// ═══════════════════════════════════════
//  COORDINATE GEOMETRY (Class 9 Ch 3, Class 10 Ch 7)
// ═══════════════════════════════════════

export function SvgCoordinatePlane() {
  return (
    <svg viewBox="0 0 400 280" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Coordinate Plane", C.text, 13, "middle", "600")}
      {/* Grid */}
      {[80,120,160,200,240,280,320].map(x => <line key={`gv${x}`} x1={x} y1="30" x2={x} y2="250" stroke="#f1f5f9" strokeWidth="1"/>)}
      {[50,90,130,170,210,250].map(y => <line key={`gh${y}`} x1="60" y1={y} x2="340" y2={y} stroke="#f1f5f9" strokeWidth="1"/>)}
      {/* Axes */}
      {arrow(60,170,340,170,C.textMid,1.5)}
      {arrow(200,250,200,30,C.textMid,1.5)}
      {label(345, 174, "x", C.textMid, 12, "start")}
      {label(204, 28, "y", C.textMid, 12, "start")}
      {label(208, 180, "O", C.textMid, 10, "start")}
      {/* Scale labels */}
      {[-3,-2,-1,1,2,3].map(n => <text key={`xl${n}`} x={200+n*40} y={186} fontSize="9" fill={C.textMute} fontFamily={ff} textAnchor="middle">{n}</text>)}
      {[-2,-1,1,2].map(n => <text key={`yl${n}`} x={192} y={170-n*40+4} fontSize="9" fill={C.textMute} fontFamily={ff} textAnchor="end">{n}</text>)}
      {/* Quadrant labels */}
      {label(270, 95, "I (+,+)", C.primaryMid, 11, "middle", "600")}
      {label(130, 95, "II (−,+)", C.amber, 11, "middle", "600")}
      {label(130, 215, "III (−,−)", C.purpleMid, 11, "middle", "600")}
      {label(270, 215, "IV (+,−)", "#E24B4A", 11, "middle", "600")}
      {/* Sample point */}
      <circle cx="280" cy="90" r="5" fill={C.primaryMid}/>
      {label(290, 85, "(2, 2)", C.primaryMid, 11, "start", "600")}
      <line x1="280" y1="170" x2="280" y2="90" stroke={C.primaryMid} strokeWidth="1" strokeDasharray="4,3"/>
      <line x1="200" y1="90" x2="280" y2="90" stroke={C.primaryMid} strokeWidth="1" strokeDasharray="4,3"/>
    </svg>
  );
}

export function SvgDistanceFormula() {
  return (
    <svg viewBox="0 0 400 240" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Distance Formula", C.text, 13, "middle", "600")}
      {/* Grid */}
      {[80,120,160,200,240,280,320].map(x => <line key={`g${x}`} x1={x} y1="35" x2={x} y2="200" stroke="#f1f5f9" strokeWidth="1"/>)}
      {[55,95,135,175].map(y => <line key={`g${y}`} x1="60" y1={y} x2="340" y2={y} stroke="#f1f5f9" strokeWidth="1"/>)}
      {/* Axes */}
      <line x1="60" y1="175" x2="340" y2="175" stroke={C.textMid} strokeWidth="1.5"/>
      <line x1="80" y1="200" x2="80" y2="35" stroke={C.textMid} strokeWidth="1.5"/>
      {/* Points */}
      <circle cx="120" cy="135" r="5" fill={C.primaryMid}/>
      {label(110, 128, "A(1,1)", C.primaryMid, 11, "end", "600")}
      <circle cx="280" cy="55" r="5" fill="#E24B4A"/>
      {label(290, 50, "B(5,4)", "#E24B4A", 11, "start", "600")}
      {/* Line AB */}
      <line x1="120" y1="135" x2="280" y2="55" stroke={C.amber} strokeWidth="2.5"/>
      {/* Right triangle */}
      <line x1="120" y1="135" x2="280" y2="135" stroke={C.primaryLight} strokeWidth="1.5" strokeDasharray="5,3"/>
      <line x1="280" y1="135" x2="280" y2="55" stroke={C.primaryLight} strokeWidth="1.5" strokeDasharray="5,3"/>
      {label(200, 150, "x₂−x₁ = 4", C.textMid, 10)}
      {label(295, 95, "y₂−y₁ = 3", C.textMid, 10, "start")}
      {/* Formula */}
      <rect x="80" y="208" width="240" height="28" rx="10" fill="#FAEEDA"/>
      {label(200, 226, "d = √[(x₂−x₁)² + (y₂−y₁)²] = √(16+9) = 5", C.amberDark, 11, "middle", "600")}
    </svg>
  );
}

// ═══════════════════════════════════════
//  QUADRILATERALS (Class 9 Ch 8)
// ═══════════════════════════════════════

export function SvgQuadrilateralTypes() {
  return (
    <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Special Quadrilaterals", C.text, 13, "middle", "600")}
      {/* Parallelogram */}
      <polygon points="40,140 90,70 170,70 120,140" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      {label(105, 160, "Parallelogram", C.primaryMid, 10, "middle", "600")}
      {label(105, 174, "opp. sides ∥ & =", C.textMute, 8, "middle")}
      {/* Rectangle */}
      <polygon points="195,140 195,70 295,70 295,140" fill="#FAEEDA" stroke={C.amberDark} strokeWidth="2"/>
      <rect x="195" y="124" width="12" height="12" fill="none" stroke={C.amberDark} strokeWidth="1"/>
      {label(245, 160, "Rectangle", C.amberDark, 10, "middle", "600")}
      {label(245, 174, "all angles 90°", C.textMute, 8, "middle")}
      {/* Square */}
      <polygon points="325,140 325,76 385,76 385,140" fill="#EEEDFE" stroke={C.purpleMid} strokeWidth="2"/>
      <rect x="325" y="124" width="12" height="12" fill="none" stroke={C.purpleMid} strokeWidth="1"/>
      {label(355, 160, "Square", C.purpleMid, 10, "middle", "600")}
      {label(355, 174, "all sides & angles =", C.textMute, 8, "middle")}
      {/* Hierarchy */}
      {label(200, 195, "Square → Rectangle → Parallelogram → Quadrilateral", C.textMid, 10)}
    </svg>
  );
}

// ═══════════════════════════════════════
//  AREAS (Class 9 Ch 9, Class 10 Ch 12)
// ═══════════════════════════════════════

export function SvgAreaTriangleCoord() {
  return (
    <svg viewBox="0 0 400 240" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Area of Triangle using Coordinates", C.text, 13, "middle", "600")}
      {/* Grid */}
      {[60,100,140,180,220,260,300,340].map(x => <line key={`g${x}`} x1={x} y1="35" x2={x} y2="195" stroke="#f1f5f9" strokeWidth="1"/>)}
      {[55,95,135,175].map(y => <line key={`g${y}`} x1="60" y1={y} x2="340" y2={y} stroke="#f1f5f9" strokeWidth="1"/>)}
      <line x1="60" y1="175" x2="340" y2="175" stroke={C.textMid} strokeWidth="1.5"/>
      <line x1="60" y1="195" x2="60" y2="35" stroke={C.textMid} strokeWidth="1.5"/>
      {/* Triangle */}
      <polygon points="100,135 260,55 300,175" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      <circle cx="100" cy="135" r="4" fill={C.primaryMid}/>
      <circle cx="260" cy="55" r="4" fill={C.primaryMid}/>
      <circle cx="300" cy="175" r="4" fill={C.primaryMid}/>
      {label(82, 130, "(1,1)", C.primaryMid, 10, "end", "600")}
      {label(260, 45, "(5,3)", C.primaryMid, 10, "middle", "600")}
      {label(310, 190, "(6,0)", C.primaryMid, 10, "start", "600")}
      {/* Formula */}
      <rect x="40" y="205" width="320" height="28" rx="10" fill="#FAEEDA"/>
      {label(200, 223, "Area = ½|x₁(y₂−y₃) + x₂(y₃−y₁) + x₃(y₁−y₂)|", C.amberDark, 11, "middle", "600")}
    </svg>
  );
}

export function SvgSectorArea() {
  return (
    <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Area of Sector & Segment", C.text, 13, "middle", "600")}
      {/* Circle */}
      <circle cx="150" cy="120" r="75" fill="none" stroke={C.textMid} strokeWidth="1.5"/>
      <circle cx="150" cy="120" r="3" fill={C.primaryMid}/>
      {label(150, 115, "O", C.text, 10, "middle", "600")}
      {/* Sector */}
      <path d="M 150 120 L 225 120 A 75 75 0 0 0 200 55 Z" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      <path d="M 170 120 A 20 20 0 0 0 164 105" fill="none" stroke={C.amber} strokeWidth="1.5"/>
      {label(178, 108, "θ", C.amber, 11, "middle", "600")}
      {label(190, 140, "sector", C.primaryMid, 10, "middle", "600")}
      {/* Segment shading */}
      <path d="M 225 120 A 75 75 0 0 0 200 55 L 225 120" fill="#EEEDFE" stroke={C.purpleMid} strokeWidth="1.5"/>
      {label(222, 82, "segment", C.purpleMid, 9)}
      {/* Formulas */}
      {label(340, 80, "Sector area:", C.textMid, 10, "middle")}
      {label(340, 95, "πr²θ / 360", C.primaryMid, 12, "middle", "600")}
      {label(340, 120, "Arc length:", C.textMid, 10, "middle")}
      {label(340, 135, "2πrθ / 360", C.primaryMid, 12, "middle", "600")}
      {label(340, 165, "Segment =", C.textMid, 10, "middle")}
      {label(340, 180, "Sector − Triangle", C.purpleMid, 11, "middle", "600")}
    </svg>
  );
}

// ═══════════════════════════════════════
//  TRIGONOMETRY (Class 10 Ch 8-9)
// ═══════════════════════════════════════

export function SvgTrigRatios() {
  return (
    <svg viewBox="0 0 400 240" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Trigonometric Ratios", C.text, 13, "middle", "600")}
      {/* Right triangle */}
      <polygon points="80,200 80,60 300,200" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2.5"/>
      {/* Right angle */}
      <rect x="80" y="182" width="16" height="16" fill="none" stroke={C.amber} strokeWidth="1.5"/>
      {/* Angle θ */}
      <path d="M 270 200 A 30 30 0 0 0 283 182" fill="none" stroke={C.amber} strokeWidth="2"/>
      {label(258, 190, "θ", C.amber, 14, "middle", "600")}
      {/* Labels */}
      {label(60, 130, "Opposite", "#E24B4A", 12, "end", "600")}
      {label(58, 145, "(P)", "#E24B4A", 10, "end")}
      {label(190, 218, "Adjacent (B)", C.purpleMid, 12, "middle", "600")}
      {label(210, 120, "Hypotenuse (H)", C.primaryMid, 12, "middle", "600")}
      {/* SOH CAH TOA */}
      <rect x="20" y="230" width="110" height="10" rx="4" fill="none"/>
      {label(40, 236, "sin θ = P/H", "#E24B4A", 11, "start", "600")}
      {label(160, 236, "cos θ = B/H", C.purpleMid, 11, "start", "600")}
      {label(290, 236, "tan θ = P/B", C.amber, 11, "start", "600")}
    </svg>
  );
}

export function SvgHeightDistance() {
  return (
    <svg viewBox="0 0 400 220" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",maxWidth:400}}>
      {label(200, 18, "Height & Distance Application", C.text, 13, "middle", "600")}
      {/* Ground */}
      <line x1="20" y1="180" x2="380" y2="180" stroke={C.textMid} strokeWidth="1.5"/>
      {/* Building */}
      <rect x="280" y="50" width="50" height="130" rx="3" fill={C.primarySoft} stroke={C.primaryMid} strokeWidth="2"/>
      {label(305, 120, "h = ?", C.primaryMid, 12, "middle", "600")}
      {/* Person */}
      <circle cx="80" cy="160" r="8" fill="#FAEEDA" stroke={C.amberDark} strokeWidth="1.5"/>
      <line x1="80" y1="168" x2="80" y2="180" stroke={C.amberDark} strokeWidth="2"/>
      {/* Line of sight */}
      <line x1="80" y1="160" x2="280" y2="50" stroke={C.amber} strokeWidth="2" strokeDasharray="6,3"/>
      {/* Angle of elevation */}
      <path d="M 120 163 A 40 40 0 0 0 110 148" fill="none" stroke="#E24B4A" strokeWidth="2"/>
      {label(135, 148, "θ", "#E24B4A", 13, "middle", "600")}
      {/* Distance */}
      {arrow(80,195,280,195,C.purpleMid,1.5)}
      {label(180, 208, "d (distance)", C.purpleMid, 11, "middle", "600")}
      {/* Formula */}
      {label(200, 230, "tan θ = h/d  →  h = d × tan θ", C.text, 12, "middle", "600")}
    </svg>
  );
}

// ═══════════════════════════════════════
//  EXPORT MAPS
// ═══════════════════════════════════════

export const GEOMETRY_SVG_MAP = {
  // Lines & Angles
  "angle-types": SvgAngleTypes,
  "parallel-transversal": SvgParallelTransversal,
  "linear-pair": SvgLinearPair,
  // Triangles
  "triangle-types": SvgTriangleTypes,
  "angle-sum-property": SvgAngleSumProperty,
  "pythagoras": SvgPythagoras,
  "similar-triangles": SvgSimilarTriangles,
  "bpt": SvgBPT,
  // Circles
  "circle-parts": SvgCircleParts,
  "tangent-circle": SvgTangentToCircle,
  "angle-semicircle": SvgAngleInSemicircle,
  // Coordinate Geometry
  "coordinate-plane": SvgCoordinatePlane,
  "distance-formula": SvgDistanceFormula,
  // Quadrilaterals
  "quadrilateral-types": SvgQuadrilateralTypes,
  // Areas
  "area-triangle-coord": SvgAreaTriangleCoord,
  "sector-area": SvgSectorArea,
  // Trigonometry
  "trig-ratios": SvgTrigRatios,
  "height-distance": SvgHeightDistance,
};
